import { DESKTOP_FORM_FIELD_COLUMNS } from './form-drawer-width'

/** Griglia due colonne per i campi form su desktop. */
export const FORM_FIELD_FULL_ROW_SX = { gridColumn: '1 / -1' }

/**
 * @param {boolean} isMobile
 * @returns {import('@mui/material').SxProps}
 */
export function getFormFieldsGridSx(isMobile) {
  if (isMobile) {
    return {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      rowGap: 0.25,
      justifyContent: 'flex-start',
    }
  }

  return {
    display: 'grid',
    gridTemplateColumns: `repeat(${DESKTOP_FORM_FIELD_COLUMNS}, minmax(0, 1fr))`,
    columnGap: 2,
    rowGap: 0.5,
    width: '100%',
    alignItems: 'start',
    alignContent: 'start',
  }
}

/**
 * Spaziatura uniforme per ogni campo in griglia (equivalente a FormControl margin="normal").
 * Il margin va solo sul contenitore, non su TextField/DatePicker interni.
 */
export const FORM_FIELD_CELL_SX = {
  width: '100%',
  minWidth: 0,
  marginTop: 1,
  marginBottom: 0.5,
  overflow: 'visible',
}

/** Spaziatura più ampia su mobile (evita campi attaccati). */
export const FORM_FIELD_CELL_SX_MOBILE = {
  width: '100%',
  minWidth: 0,
  marginTop: 1.25,
  marginBottom: 0.75,
  overflow: 'visible',
}

/** Date/time picker: nessun margin aggiuntivo (evita disallineamento tra colonne). */
export const FORM_PICKER_FIELD_SX = { width: '100%' }
